import React from 'react';
import { FILTER_CONFIG_NAMES } from './DataConstants';
import { getIsActiveFilterField } from './FilterUtils';
import LabelDisplay from '../components/LabelDisplay';

export const LABEL_FILTER_RENDER_FIELDS = {
	labelAccessor: (tag) => <LabelDisplay tag={tag} />,
	renderItem: (tag) => <LabelDisplay tag={tag} />,
	renderSelectedText: (tag) => tag.label,
};

export const getPartsFilterConfig = ({ filters, updateFilters, targetCollectionName }) => {
	const vendorFilter = filters[FILTER_CONFIG_NAMES.DEFAULT_VENDORS]
		? {
				...filters[FILTER_CONFIG_NAMES.DEFAULT_VENDORS],
				handleChange: undefined,
		  }
		: null;

	const labelsFilter = filters[FILTER_CONFIG_NAMES.LABELS]
		? {
				...filters[FILTER_CONFIG_NAMES.LABELS],
				handleChange: undefined,
				...LABEL_FILTER_RENDER_FIELDS,
		  }
		: null;

	const manufacturerFilter = filters[FILTER_CONFIG_NAMES.PART_MANUFACTURER_NAME]
		? {
				...filters[FILTER_CONFIG_NAMES.PART_MANUFACTURER_NAME],
				handleChange: undefined,
		  }
		: null;

	return [
		getIsActiveFilterField(updateFilters, targetCollectionName, true),
		vendorFilter,
		labelsFilter,
		manufacturerFilter,
	].filter(Boolean);
};
